<template>
  <!-- 顶部tab组件 （项目库 某个项目详情页） author: zhangxiaofeng-->
  <div class="tab-title">
    <slot></slot>
    <ul>
      <li v-for="(item, idx) in list"
          @click="changeTab(item)"
          :class="[active == item.value ? 'active' : '']"
          :key="'tab_title_item' + idx">
        {{item.name}}
        <i></i>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TabTitle',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    active: {}
  },
  data () {
    return {
      current: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 1. init
    init () {
      this.current = this.active !== undefined ? this.active : ''
      this.current += ''
      if (this.list.length && this.current === '') {
        this.current = this.list[0].value + ''
      }
    },
    // 2. tab 切换时
    changeTab (item) {
      if (this.current !== item.value) {
        this.current = item.value + ''
        this.$emit('change', item)
      }
    }
  },
  watch: {
    'active': function () {
      this.init()
    }
  }
}
</script>
<style lang="less" type="text/less">
  .tab-title{
    height: 20px;
    line-height: 20px;
    padding: 25px 0;
    text-align: center;
    position: relative;
    li{
      display: inline-block;
      margin: 0 20px;
      position: relative;
      cursor: pointer;
      i{
        visibility: hidden;
        z-index: -1;
        display: inline-block;
        height: 5px;
        width: 100%;
        background: #1c6ccd;
        position: absolute;
        bottom: -10px;
        left: 0;
        border-radius: 5px;

      }
      &.active{
        color: #1c6ccd;
        i{
          visibility: visible;
          z-index: 10;
        }
      }
    }
  }
</style>
